import type { Violation } from '@/domain/rules/writeRules';

export { IntegrityError } from './crypto/envelope';
export { WrongSecretError } from './crypto/vault';

export class ValidationError extends Error {
  constructor(public readonly issues: string[]) {
    super(`스키마 검증 실패: ${issues.slice(0, 3).join('; ')}`);
    this.name = 'ValidationError';
  }
}

export class InvariantError extends Error {
  constructor(public readonly violations: Violation[]) {
    super(`허용되지 않는 변경: ${violations.map((v) => v.code + (v.field ? `(${v.field})` : '')).join(', ')}`);
    this.name = 'InvariantError';
  }
}

/** 다른 탭·기기에서 먼저 바뀐 기록을 덮어쓰려 할 때. 조용한 last-write-wins를 막는다. */
export class RevisionConflictError extends Error {
  constructor(
    public readonly entityType: string,
    public readonly id: string,
    public readonly expected: number,
    public readonly actual: number,
  ) {
    super(`기록이 다른 곳에서 먼저 수정되었습니다 (예상 rev ${expected}, 실제 ${actual})`);
    this.name = 'RevisionConflictError';
  }
}

export class NotFoundError extends Error {
  constructor(entityType: string, id: string) {
    super(`${entityType} ${id} 없음`);
    this.name = 'NotFoundError';
  }
}

export class StorageFullError extends Error {
  constructor() {
    super('기기 저장 공간이 부족해 저장하지 못했습니다. 기존 데이터는 그대로입니다.');
    this.name = 'StorageFullError';
  }
}

export class LockedError extends Error {
  constructor() {
    super('앱이 잠겨 있습니다');
    this.name = 'LockedError';
  }
}

export function isQuotaError(e: unknown): boolean {
  const name = (e as { name?: string; inner?: { name?: string } } | null)?.name;
  const inner = (e as { inner?: { name?: string } } | null)?.inner?.name;
  return name === 'QuotaExceededError' || inner === 'QuotaExceededError';
}
